import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import config from '@/config/index';
import { useSubscriptionUpgradeModal } from '@/modules/saas-upgrade';
import { Alert, Button, Icon, Link } from '@/modules/ui';

import { MAX_SAAS_SECRETS_COUNT } from '../../constants';
import { useSaasCountReached } from '../../hooks/useSaasCountReached';
import * as felaRules from './SecretsCountAlert.rules';

export interface SecretsCountAlertProps {}

export const SecretsCountAlert = () => {
    const { count, isError, isWarning } = useSaasCountReached();
    const { openUpgradeModal } = useSubscriptionUpgradeModal();

    const type = isError ? 'error' : 'warning';

    if (!isWarning && !isError) {
        return null;
    }

    return (
        <Alert
            showIcon
            icon={<Icon type='warning' width={20} height={20} />}
            size='fullWidth'
            customStyle={felaRules.container}
            message={
                <FormattedMessage
                    id='secret.count-alert'
                    values={{
                        count,
                        maxCount: MAX_SAAS_SECRETS_COUNT,
                        a1: (parts: ReactNode) => (
                            <Button size='middle' type='link' underline inheritColor onClick={openUpgradeModal}>
                                {parts}
                            </Button>
                        ),
                        a2: (parts: ReactNode) => (
                            <Link size='regular' type='native' inheritColor href={config.links.freeTierUpgrade}>
                                {parts}
                            </Link>
                        ),
                    }}
                />
            }
            type={type}
            data-testid={`secrets-count-saas-alert-${type}`}
        />
    );
};
